<template>
  <div class="card-body bg-light">
    <h5 class="text-left">
      {{ formTitle }}
    </h5>

    <form class="form">
      <ReadOnlyField
        :value="item[displayFieldName]"
        :fieldName="itemType"
        :displayLabel="true"
      />
      <MoneyField fieldName="Amount" v-model="amount" />
      <NotesField v-model="notes" />
      <SubmitButton
        :buttonText="formTitle"
        :loading="loading"
        @submit="emitForm"
      />
    </form>
  </div>
</template>

<script>
import NotesField from "@/components/formFieldComponents/NotesField.vue";
import MoneyField from "@/components/formFieldComponents/MoneyField.vue";
import ReadOnlyField from "@/components/formFieldComponents/ReadOnlyField.vue";
import SubmitButton from "@/components/formFieldComponents/SubmitButton.vue";

export default {
  name: "AddRemoveMoney",
  props: {
    formTitle: {
      type: String,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    item: Object,
    itemType: String,
    displayFieldName: String,
  },
  data() {
    return {
      amount: 0,
      notes: "",
    };
  },
  computed: {},
  methods: {
    emitForm() {
      if (this.amount) {
        this.$emit("form-submission", {
          amount: this.amount * 100,
          notes: this.notes,
        });
      }
    },
  },
  components: {
    NotesField,
    MoneyField,
    ReadOnlyField,
    SubmitButton,
  },
};
</script>

<style scoped></style>
